import { render } from "./recording.vue?vue&type=template&id=98c728dc&scoped=true"
import script from "./recording.vue?vue&type=script&lang=js"
export * from "./recording.vue?vue&type=script&lang=js"

import "./recording.vue?vue&type=style&index=0&id=98c728dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-98c728dc"

export default script